<template>
    <div>
        <span class="my-button">
            {{displayName}}
            <van-icon
                    v-if="!readOnly"
                    name="cross"
                    @click="deleteCallback">
            </van-icon>
        </span>
        <br/>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                displayName: ''
            }
        },
        name: "myButton",
        props: ['fileName', 'fileId', 'clArray', 'index', 'readOnly'],
        methods: {
            deleteCallback: function () {
                this.$emit("deleteEvent", this.fileId, this.clArray, this.index);
            },
            displayProcessor: function () {
                let fileName = this.fileName;
                if (fileName && fileName.length > 15) {
                    let displayName = fileName.slice(0, 15) + '...' + fileName.slice(fileName.lastIndexOf('.'));
                    this.displayName = displayName;
                } else {
                    this.displayName = fileName;
                }
            }
        },
        created() {
            this.displayProcessor();
        }
    }
</script>

<style scoped>
    .my-button {
        background: rgb(245, 245, 245);
        border-radius: 15px;
        font-size: 16px;
        display: inline-block;
        margin-bottom: 15px;
    }
</style>
